export default class UniqueUsername {
  constructor($q, AccountService) {
    'ngInject';

    Object.assign(this, {
      $q,
      AccountService
    });

    this.require = 'ngModel';
    this.restrict = 'A';
  }

  link($scope, element, attrs, ctrl) {
    let userId = null;

    if (attrs.userId) {
      userId = attrs.userId;
    }

    // Async validator requires resolve or reject to set validity
    ctrl.$asyncValidators.uniqueUsername = (username) => {
      const defer = this.$q.defer();

      this.AccountService.isUniqueUsername(username, userId)
        .then((r) => {
          if (r.data) {
            defer.resolve();
          }

          defer.reject();
        }).catch(() => defer.reject());

      return defer.promise;
    };
  }

  static directiveFactory($q, AccountService) {
    'ngInject';

    return new UniqueUsername($q, AccountService);
  }
}



// WEBPACK FOOTER //
// ./common/directives/validation/unique-username.js